var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"dragstart":_vm.startDrag,"drop":function($event){$event.preventDefault();return _vm.dropped.apply(null, arguments)},"dragover":function($event){$event.preventDefault();_vm.dragging = true},"dragenter":function($event){$event.preventDefault();_vm.dragging = true},"dragleave":function($event){$event.preventDefault();_vm.dragging = false},"dragend":function($event){$event.preventDefault();_vm.dragging = false}}},[_c('form',{ref:"uploadForm",staticClass:"form-inline d-inline",attrs:{"role":"form","enctype":"multipart/form-data"}},[_c('input',{ref:"uploadInput",staticStyle:{"display":"none"},attrs:{"type":"file","multiple":"true","accept":_vm.accept},on:{"change":_vm.uploaded}})]),_vm._v(" "),_vm._t("default",null,null,{
			accept: _vm.accept,
			browse: _vm.browse,
			canMerge: _vm.canMerge,
			deleted: _vm.deleted,
			dragging: _vm.dragging,
			empty: _vm.empty,
			folders: _vm.folders,
			files: _vm.files,
			loading: _vm.loading,
			merge: _vm.merge,
			merging: _vm.merging,
			prefix: _vm.prefix,
			refresh: _vm.refresh,
			renamed: _vm.renamed,
			results: _vm.results,
			listSubmitResult: _vm.listSubmitResult,
			listSubmitHisttoryResult: _vm.listSubmitHisttoryResult,
			selected: _vm.selected,
			service: _vm.service,
			uploading: _vm.uploading,
			uploadPercent: _vm.uploadPercent,
			zip: _vm.zip,
			zipping: _vm.zipping,
		    responseListAppealOtherDocumentResult: _vm.responseListAppealOtherDocumentResult,
		})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }